import { PersonIdent } from 'fobclient/lib/entity'

export default {
  label: 'PersonIdent',
  field: 'personIdent',
  type: 'object',
  cardinality: 'many',
  onlyCreate: true,
  render: 'embedded',
  schema: {
    route: 'personIdent',
    class: PersonIdent,
    className: 'personIdent',
    entityName: 'de.ul.fob.domain.PersonIdent',
    fields: [
      {
        label: 'PersonIdent.form.personIdentTyp',
        field: 'personIdentTyp',
        entity: 'personIdentTyp',
        type: 'prefetchedObject',
        render: 'stringRep',
        cardinality: 'single',
        schema: {
          route: 'personidenttyp',
          className: 'personIdentTyp',
          fields: [
            {
              label: 'Name',
              field: 'name'
            }
          ]
        },
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0
        }
      },
      {
        label: 'PersonIdent.form.wert',
        field: 'wert',
        view (data) {
          return !(data.externalLink && data.externalLink.href)
        }
      },
      {
        field: 'externalLink',
        label: 'PersonIdent.form.wert',
        type: 'link',
        view (data) {
          return data.externalLink && data.externalLink.href
        },
        computed (data) {
          let hrefs = {
            gepris: (id) => `https://gepris.dfg.de/gepris/person/${id}`,
            orcid: (id) => `https://orcid.org/${id}`,
            researcherid: (id) => `https://publons.com/researcher/${id}`,
            'gnd-id': (id) => `https://d-nb.info/gnd/${id}`,
            'scopus author id': (id) =>
              `https://www.scopus.com/authid/detail.uri?authorId=${id}`,
            uri: (id) => id
          }
          let ityp = data.personIdentTyp.kennung.toLowerCase()
          let wert = data.wert.trim()
          let href = null

          if (hrefs[ityp] && hrefs[ityp](wert)) {
            href = encodeURI(hrefs[ityp](wert))
          }

          return { href, text: wert }
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/schema/PersonIdent.js